module.exports = __webpack_public_path__ + "img/11.20352ba5.jpg";